'use strict';

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'productsSlider', () => ({

		track      : null,
		dotsWrap   : null,
		realSlides : [],
		total      : 0,
		_jumping   : true,
		atStart    : true,
		atEnd      : false,
		scrollTimer: null,
		resizeTimer: null,

		init() {
			this.track      = this.$el.querySelector( '[data-slider-track]' );
			this.dotsWrap   = this.$el.querySelector( '[data-slider-dots]' );
			this.realSlides = Array.from( this.track.querySelectorAll( '.product-slide' ) );
			this.total      = this.realSlides.length;
			if ( ! this.total ) return;

			this.track.scrollLeft = 0;
			this.buildDots();
			this.updateNavState();

			// ── Scroll listener ───────────────────────────────────────────────
			this.track.addEventListener( 'scroll', () => {
				this.checkBounds();
				this.updateNavState();
				clearTimeout( this.scrollTimer );
				this.scrollTimer = setTimeout( () => this.updateDots(), 50 );
			}, { passive: true });

			// ── Desktop wheel ─────────────────────────────────────────────────
			const wrap = this.$el.querySelector( '[data-slider-wrap]' );
			wrap.addEventListener( 'wheel', ( e ) => {
				if ( 1024 > window.innerWidth ) return;
				if ( Math.abs( e.deltaX ) > Math.abs( e.deltaY ) ) return;
				const atStart = 0 >= this.track.scrollLeft;
				const atEnd   = this.track.scrollLeft + this.track.offsetWidth >= this.track.scrollWidth - 1;
				if ( ( 0 > e.deltaY && atStart ) || ( 0 < e.deltaY && atEnd ) ) return;
				e.preventDefault();
				this.track.scrollBy({
					left    : e.deltaY * 2,
					behavior: 'auto'
				});
			}, { passive: false });

			// ── Image drag prevention ─────────────────────────────────────────
			this.track.querySelectorAll( 'img' ).forEach( ( img ) => {
				img.addEventListener( 'dragstart', ( e ) => {
					e.preventDefault();
				});
			});

			// ── Resize ────────────────────────────────────────────────────────
			window.addEventListener( 'resize', () => {
				clearTimeout( this.resizeTimer );
				this.resizeTimer = setTimeout( () => {
					this.buildDots();
					this.updateDots();
					this.updateNavState();
				}, 150 );
			});
		},

		// ── Helpers ───────────────────────────────────────────────────────────

		getSlideWidth() {
			return this.realSlides[0] ? this.realSlides[0].offsetWidth : 0; // eslint-disable-line
		},

		getSlidesPerView() {
			const w = window.innerWidth;
			if ( 1024 <= w ) return 4.5;
			if ( 640 <= w )  return 2;
			return 1.5;
		},

		getMaxIndex() {
			return Math.max( 0, this.total - Math.floor( this.getSlidesPerView() ) );
		},

		getCurrentIndex() {
			if ( ! this.realSlides.length ) return 0;
			const slideWidth = this.getSlideWidth();
			if ( 0 === slideWidth ) return 0;
			const idx = Math.round( this.track.scrollLeft / slideWidth );
			return Math.min( idx, this.total - 1 );
		},

		// ── Infinite loop jump ────────────────────────────────────────────────

		checkBounds() {
			if ( this._jumping ) return;
			const slideW = this.getSlideWidth();
			if ( ! slideW ) return;

			if ( this.track.scrollLeft >= this.total * slideW ) {
				this._jumping                   = true;
				this.track.style.scrollBehavior = 'auto';
				this.track.scrollLeft           = 0;
				requestAnimationFrame( () => {
					requestAnimationFrame( () => {
						this.track.style.scrollBehavior = '';
						this._jumping                   = false;
					});
				});
			}
		},

		// ── Nav state ─────────────────────────────────────────────────────────

		updateNavState() {
			this.atStart = 0 >= this.track.scrollLeft;
			this.atEnd   = this.track.scrollLeft + this.track.offsetWidth >= this.track.scrollWidth - 1;
		},

		scrollPrev() {
			this.track.scrollBy({ left: -this.getSlideWidth(), behavior: 'smooth' });
		},

		scrollNext() {
			this.track.scrollBy({ left: this.getSlideWidth(), behavior: 'smooth' });
		},

		// ── Dots ──────────────────────────────────────────────────────────────

		buildDots() {
			if ( ! this.dotsWrap ) return;
			this.dotsWrap.innerHTML = '';
			const maxIndex = this.getMaxIndex();
			for ( let i = 0; i < maxIndex; i++ ) {
				const dot = document.createElement( 'button' );
				dot.className = 'products-slider-dot' + ( 0 === i ? ' is-active' : '' ); // eslint-disable-line
				dot.setAttribute( 'aria-label', 'Go to slide ' + ( i + 1 ) );
				dot.dataset.index = i;
				dot.addEventListener( 'click', () => {
					const idx        = parseInt( dot.dataset.index, 10 );
					const slideWidth = this.getSlideWidth();
					this.track.scrollTo({ left: idx * slideWidth, behavior: 'smooth' });
				});
				this.dotsWrap.appendChild( dot );
			}
		},

		updateDots() {
			if ( ! this.dotsWrap ) return;
			const current = this.getCurrentIndex();
			this.dotsWrap.querySelectorAll( '.products-slider-dot' ).forEach( ( dot, idx ) => {
				dot.classList.toggle( 'is-active', idx === current );
			});
		},
	}) );
});
